import React from "react";
import { Box, Typography, Button } from "@mui/material";
import axios from "axios";

import { logDev } from "../utils/logger.js";

import { useGroupe } from "../context/GroupeContext.js"; // 👈 pour récupérer groupeId
import { useLanguage } from '../context/LanguageContext.js';

// ------------------------------------------------------------
// Composant : ChoixPeriodeDominante
// ------------------------------------------------------------
// Affiche des boutons permettant à l’admin de choisir manuellement
// la période dominante lorsqu’il y a égalité entre plusieurs périodes.
// ------------------------------------------------------------

const ChoixPeriodeDominante = ({ isAdmin, dominantKeys, periodePrivilegiee, setPeriodePrivilegiee }) => {
  const { groupeId } = useGroupe(); // 👈 récupère l’ID du groupe
  const { t } = useLanguage();
  logDev("[ChoixPeriodeDominante] rendu", { isAdmin, dominantKeys, periodePrivilegiee, groupeId });
  logDev("[ChoixPeriodeDominante] dominantKeys reçus", dominantKeys);

  // Si l’utilisateur n’est pas admin OU s’il n’y a pas d’égalité,
  // on n’affiche rien du tout.
  if (!isAdmin || dominantKeys.length <= 1) return null;

  // Handler : quand l’admin clique sur une période
  const handleChoixPeriode = async (key) => {
    // On garde l’ancienne valeur au cas où la sauvegarde échoue
    const previous = periodePrivilegiee;

    try {
      // 📝 Log avant de changer quoi que ce soit
      logDev("[ChoixPeriodeDominante] clic admin", { choisi: key, previous, groupeId });

      // 1️⃣ Mise à jour immédiate de l’UI
      setPeriodePrivilegiee(key);

      // 2️⃣ Enregistrement en base
      await axios.put(`${process.env.REACT_APP_API}/groupes/${groupeId}/periodePrivilegiee`, {
        periodePrivilegiee: key,
      });

      logDev("✅ Choix admin enregistré en base", key);
    } catch (err) {
      logDev("❌ Erreur enregistrement choix admin", { message: err.message, stack: err.stack });

      // Si erreur → on restaure l’ancienne valeur
      setPeriodePrivilegiee(previous);
    }
  };

  // Rendu du composant
  return (
    <Box sx={{ textAlign: "center", mb: 2 }}>
      <Typography variant="body2" sx={{ mb: 1 }}>
        {t('SeveralPeriodsTied')}
      </Typography>

      {/* Liste des périodes ex æquo */}
      {dominantKeys.map(({_id, start, end}) => (
        <Button
          key={_id}
          // ⭐⭐ C’est ICI que la période sélectionnée est mise en couleur
          variant={periodePrivilegiee === _id ? "contained" : "outlined"}
          color="secondary"
          size="small"
          onClick={() => handleChoixPeriode(_id )} // Quand on clique → on choisit cette période
          sx={{ mx: 0.5 }}
        >
          {/* Affichage des dates de la période */}
          {new Date(start).toLocaleDateString()} → {new Date(end).toLocaleDateString()}
        </Button>
      ))}
    </Box>
  );
};

export default ChoixPeriodeDominante;
